export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11240.2860c0e3.jpg";